import { useEffect, useState } from "react";
import "./hero3dvideo.css";

export default function Hero3D() {
  // 04.07.2026. u 10:00h
  const targetDate = new Date(2026, 6, 4, 10, 0, 0);

  const [time, setTime] = useState(getTime());

  function getTime() {
    const diff = targetDate.getTime() - Date.now();

    return {
      days: Math.max(0, Math.floor(diff / 86400000)),
      hours: Math.max(0, Math.floor((diff / 3600000) % 24)),
      minutes: Math.max(0, Math.floor((diff / 60000) % 60)),
      seconds: Math.max(0, Math.floor((diff / 1000) % 60)),
    };
  }

  useEffect(() => {
    const i = setInterval(() => setTime(getTime()), 1000);
    return () => clearInterval(i);
  }, []);

  return (
    <div className="hero3d">

      {/* 🎥 VIDEO BACKGROUND */}
      <video
        className="bg-video"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src="/videos/event.mp4" type="video/mp4" />
      </video>

      {/* 🌫 OVERLAY */}
      <div className="overlay"></div>

      {/* 💡 GLOW EFFECT */}
      <div className="glow"></div>

      {/* CONTENT */}
      <div className="content">

        <p className="tag">PARK VOZAČA, PILA</p>

        <h1 className="title">
          GHOST ATTACK 2.0
        </h1>

        <p className="subtitle">
          Subota 04.07.2026.
        </p>

        {/* COUNTER */}
        <div className="counter">
          <div>{time.days} <span>Dana</span></div>
          <div>{time.hours} <span>Sati</span></div>
          <div>{time.minutes} <span>Minuta</span></div>
          <div>{time.seconds} <span>Sekundi</span></div>
        </div>

       <button
            className="cta"
            onClick={() => window.location.href = "/prijava"}
          >
            PRIJAVI SE!
          </button>

      </div>
    </div>
  );
}